import { useEventListener } from "usehooks-ts"

export const useKeydown = (keyCodeToUse: number, handler: () => void): void => {
  useEventListener("keydown", ({ keyCode }: KeyboardEvent) => {
    if (keyCode === keyCodeToUse) {
      handler()
    }
  })
}
